const formCalendarPicker = {
  update: (field, appData, { tabIndex }) => {
    const { values, settings } = appData;
    const {
      translations: {
        please_pick_a_date: dateErrorMessage,
        you_must_select_at_least_one_time_slot: slotErrorMessage,
        please_make_sure_all_three_times_are_different: sameSlotsErrorMessage,
        visit_date: dateGroupErrorMessage,
        visit_time: timeGroupErrorMessage
      }
    } = settings;
    const isRequired = true;
    const selectionsState = {};
    let isValid = true;
    let errorMessage = "";
    let groupErrorMessage = "";
    let secondaryGroupErrorMessage = "";

    const {
      data: { selections },
      title,
      name: fieldName
    } = field;

    selections.forEach((selection, index) => {
      const { name, placeholder } = selection;
      selectionsState[name] = {
        selectionErrorMessage: sameSlotsErrorMessage
      };
      const sameTimes =
        selections.length > 1 &&
        Object.values(values).filter(value => value && value === values[name])
          .length > 1;

      if (!values[name] || sameTimes) {
        isValid = false;
        errorMessage = sameSlotsErrorMessage;

        if (sameTimes) {
          groupErrorMessage = `${placeholder} ${timeGroupErrorMessage}`;
          secondaryGroupErrorMessage = groupErrorMessage;
        }
      }

      if (!values[name]) {
        errorMessage = dateErrorMessage;
        selectionsState[name] = {
          selectionErrorMessage: dateErrorMessage
        };

        if (!secondaryGroupErrorMessage) {
          secondaryGroupErrorMessage = dateGroupErrorMessage;
        }

        if (index === tabIndex) {
          groupErrorMessage = dateGroupErrorMessage;
        }
      }

      if (values[name] === null) {
        errorMessage = slotErrorMessage;
        selectionsState[name] = {
          selectionErrorMessage: slotErrorMessage,
          hasErrorStatus: true
        };

        if (selections.length > 1) {
          secondaryGroupErrorMessage = `${placeholder} ${timeGroupErrorMessage}`;

          if (index === tabIndex) {
            groupErrorMessage = `${placeholder} ${timeGroupErrorMessage}`;
          }
        } else {
          groupErrorMessage = timeGroupErrorMessage;
        }
      }

      if (values[name]) {
        selectionsState[name] = {
          ...selectionsState[name],
          hasErrorStatus: false
        };
        if (index === tabIndex) {
          groupErrorMessage = secondaryGroupErrorMessage;
        }
      }
    });

    const fieldObject = {
      fieldName,
      isValid,
      isRequired,
      errorMessage,
      title,
      selectionsState,
      groupErrorMessage: groupErrorMessage || secondaryGroupErrorMessage
    };

    const fieldsArray = appData.screenValidation.fields;
    const index = fieldsArray.findIndex(
      fieldItem => fieldItem.fieldName === field.name
    );

    if (index > -1) {
      fieldsArray[index] = fieldObject;
    } else {
      fieldsArray.push(fieldObject);
    }
    return fieldObject;
  }
};

export default formCalendarPicker;
